import { humansClient } from '../sdk/administrationClient.js';

import { defineAdministrationCollectionStore } from './administrationCollectionStore.js';

/**
 * Humans, as Platform Administration lists them: a page of people by name or email, one person
 * with their logins, devices and sessions, and the one write — ending a person's sessions, on
 * one device or everywhere.
 */
export const humansStore = defineAdministrationCollectionStore({
    id: 'administration-humans',
    client: humansClient,
    extend({ client, attempt }) {
        /**
         * Sign one of the person's devices out, named by the session row's `id`, or every
         * device when none is named. The held record is stale afterwards; `refresh` re-reads it.
         */
        async function endSessions(humanId, device) {
            const attempted = await attempt(function () {
                return client.endSessions(humanId, { device });
            });
            return attempted.ok;
        }

        /**
         * Close the person's account, as the person would from Sign-in & security: contact
         * details stripped, logins dormant, every session ended, restorable by signing in
         * again with any old login. The held record is stale afterwards; `refresh` re-reads it.
         */
        async function close(humanId) {
            const attempted = await attempt(function () {
                return client.close(humanId);
            });
            return attempted.ok;
        }

        return { endSessions, close };
    }
});

export default humansStore;
